export class GetEventItemFormRequest {
   EventItemId : string;
   IncludeRead: boolean;
}